import React from 'react';
import {useMatch, useNavigate} from 'react-router-dom';
interface ProductsProps {
  products?: Array<IFarmProductsData>;
}
const Products = ({products}: ProductsProps) => {
  const navigate = useNavigate();

  const isFarmRoute = useMatch('/farm/add-ad/purchase');

  return (
    <div className="flex flex-col gap-4  h-[75%] w-full items-start">
      {products?.map((item, index) => {
        return (
          <button
            className="flex gap-2 items-center"
            key={index}
            onClick={() => {
              navigate(
                `${
                  isFarmRoute ? '/farm' : '/wholesaler'
                }/add-ad/purchase/products/${item.guid}`,
              );
            }}
          >
            {item.icon && <span className={` text-primary  ${item.icon}`} />}
            <div className="text-gray-6 font-medium text-[15px] leading-[20px] ">
              {item.title}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default Products;
